/**
 * Types for the vertical alignment of the thumbnails menu of the `ui5-media-gallery` component.
 * @public
 */
enum MediaGalleryMenuVerticalAlign {
	/**
	 * Displays the menu at the top of the reference control.
	 * @public
	 */
	Top = "Top",

	/**
	 * Displays the menu at the bottom of the reference control.
	 * @public
	 */
	Bottom = "Bottom",
}

export default MediaGalleryMenuVerticalAlign;
